import { createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset.tsx";
import PageLayoutRoot, {
  PageLayoutContent,
  PageLayoutHeader,
} from "@/components/page-layout.tsx";
import VirtualTerminalFormContainer from "@/app/(authenticated)/$merchantId/virtual-terminal/_components/virtual-terminal-form-container.tsx";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/virtual-terminal/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ContainerInset
      breadcrumbs={[
        {
          title: "Virtual Terminal",
          href: "#",
        },
      ]}
    >
      <PageLayoutRoot>
        <PageLayoutHeader
          title={"Virtual Terminal"}
          description="Take a few moments to register for your company's workspace"
        />
        <PageLayoutContent>
          <VirtualTerminalFormContainer />
        </PageLayoutContent>
      </PageLayoutRoot>
    </ContainerInset>
  );
}
